import AvatarEditor from "react-avatar-editor";
import { useImageCropContext } from "../ImageCropProvider";
import { useDebugMode } from "components/DebugContext/DebugContext";
import React from "react";

interface CropperProps {
  avatarEditorRef: React.RefObject<AvatarEditor>;
  aspectRatio?: number;
  outputSize?: number;
}

const Cropper = (props: CropperProps) => {
  const { debugMode } = useDebugMode();

  const { image, zoom, crop, setCrop }: any = useImageCropContext();
  const { avatarEditorRef, aspectRatio = 1, outputSize = 355 } = props; 

  let width: number;
  let height: number;
  if (aspectRatio >= 1) {
    height = outputSize;
    width = Math.round(outputSize * aspectRatio);
  } else {
    width = outputSize;
    height = Math.round(outputSize / aspectRatio);
  }

  return (
    <>
      <AvatarEditor
        ref={avatarEditorRef}
        scale={zoom}
        width={width}
        height={height}
        position={crop}
        showGrid={false}
        onPositionChange={(p) => setCrop(p)}
        borderRadius={aspectRatio === 1 ? width / 2 : 0}
        border={0}
        backgroundColor={"#fff"}
        onLoadFailure={() => debugMode && console.log("onLoadFailure")}
        onLoadSuccess={() => debugMode && console.log("onLoadSuccess")}
        onImageReady={() => debugMode && console.log("onImageReady")}
        image={image}
      />
    </>
  );
};

export default Cropper;
